import React, { memo } from "react";

import Button from "./Button";
import { Link, useNavigate } from "react-router-dom";
import { useInternalHistory } from "../../Hooks";

const SubHeading = ({
  subTitle = "",
  isAdd = false,
  handleShowHide,
  isImport = false,
  isAddBtnPage = false,
  redirectPath = "",
  isDynamic = false,
  dynamicBtnName = "",
  onClick,
  createAccess = false,
  updateAccess = false,
  isRestartService = false,
  isBack = false,
}) => {
  const navigate = useNavigate();

  const history = useInternalHistory();
  const handleBack = () => {
    if (history.length > 1) {
      const prev = history[history.length - 2];
      history.pop(); // remove current page
      navigate(prev);
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <>
      <div className="heading_market sub_heading ">
        <h2 className="text_hade">{subTitle}</h2>
      </div>

      <div className="col-auto ms-auto m-0 p-0 d-flex">
        {isImport && (
          <Button icon="FaPlus" className="btn btn_main" onClick={onClick}>
            Import
          </Button>
        )}

        {isAdd && (
          <Button
            icon="FaPlus"
            className="btn btn_main"
            onClick={() => handleShowHide("add")}
          >
            Add
          </Button>
        )}

        {isAddBtnPage && createAccess && (
          <Button icon="FaPlus" className="m-1 btn_add">
            <Link to={redirectPath}>Add link</Link>
          </Button>
        )}

        {isDynamic && updateAccess && (
          <Button className="m-1 btn_add" onClick={onClick}>
            {dynamicBtnName}
          </Button>
        )}

        {isRestartService && (
          <Button className="m-1" onClick={onClick}>
            Restart
          </Button>
        )}
        {isBack && (
          <Button type="button" className="btn btn_main" onClick={handleBack}>
            Back
          </Button>
        )}
      </div>
      {/* </div> */}
    </>
  );
};

export default memo(SubHeading);
